import { Link } from "react-router-dom";
import { MessageCircle, ChevronRight } from "lucide-react";

export default function AskStarsBanner({ to, testId, showFree = true, className = "" }) {
  return (
    <Link
      to={to}
      data-testid={testId}
      className={`flex items-center justify-between bg-[#0F1523] border border-[#D4AF37]/40 hover:border-[#D4AF37]/70 rounded-2xl px-5 py-4 transition-colors ${className}`}
    >
      <span className="flex items-center gap-2 text-[#E8DCC4]">
        <MessageCircle size={16} className="gold-text shrink-0" />
        <span>Ask the stars with <span className="gold-text">Astra Interactive</span>{showFree && " – try it now for free"}</span>
      </span>
      <ChevronRight size={16} className="gold-text shrink-0" />
    </Link>
  );
}
